// Radix Popover portals its panel to `document.body` with `position: fixed`
// and relies on floating-ui's autoUpdate to reposition when the trigger
// moves. That auto-update only reliably watches window + known scroll
// ancestors — when a trigger sits inside a nested scroll container (drawer
// body, dialog body), the panel stays frozen at its initial fixed position
// while the trigger scrolls away, giving a "flying away" effect.
//
// Standard dropdown UX across the web: close the dropdown on scroll. This
// shim installs one capture-phase scroll listener at window level and, if
// a Radix popper is open AND the scroll did not originate inside the popper
// itself, dispatches Escape on the popper content. Radix's DismissableLayer
// catches the key and closes only the topmost open layer — parent dialog /
// drawer stays open.

const POPPER_SELECTOR = "[data-radix-popper-content-wrapper]";

function closeOpenPoppers() {
  const poppers = document.querySelectorAll<HTMLElement>(POPPER_SELECTOR);
  poppers.forEach((popper) => {
    popper.dispatchEvent(
      new KeyboardEvent("keydown", {
        key: "Escape",
        code: "Escape",
        bubbles: true,
        cancelable: true,
      }),
    );
  });
}

function onScrollCapture(event: Event) {
  const target = event.target as Element | Document | null;
  // Ignore scroll events originating inside the popper itself (e.g. the
  // user is scrolling the country list / listbox). Those must keep working.
  if (target instanceof Element && target.closest(POPPER_SELECTOR)) return;

  closeOpenPoppers();
}

let installed = false;

export function installRadixPopoverScrollClose() {
  if (installed) return;
  installed = true;
  window.addEventListener("scroll", onScrollCapture, {
    capture: true,
    passive: true,
  });
}
